import { ICompanyState, CompanyActions } from "./company.interface";

export function setCompany(company: ICompanyState){
  return {
    type: CompanyActions.SET_COMPANY,
    payload: { company }
  }
}

export function ClearCompany(){
  return {
    type: CompanyActions.CLEAR_COMPANY
  }
}